// Archivo: assets/animacionCarrito.js
;(() => {
  // Evita doble inicialización si el archivo se inyecta 2 veces
  if (window.__AnimCarritoInit) return;
  window.__AnimCarritoInit = true;

  // === CONFIG ===
  const BACKEND_URL = 'https://vps.bitandbyte.com.mx/api/guardar-datos';

  // === Utils ===
  function isIE() {
    const ua = navigator.userAgent;
    return ua.includes('MSIE ') || ua.includes('Trident/');
  }

  // Forzar recarga si vuelven con “atrás” (bfcache)
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) window.location.reload();
  });

  // =========================
  // Overlay de carga (SVG)
  // =========================
  function ensureOverlayStyles() {
    if (document.getElementById('loading-overlay-styles')) return;
    const style = document.createElement('style');
    style.id = 'loading-overlay-styles';
    style.textContent = `
      #loading-overlay .loading-logo-svg{width:300px;height:auto;overflow:visible;margin-left:6%}
      @keyframes floatUp{0%{transform:translateY(0);opacity:.8}100%{transform:translateY(-10px);opacity:1}}
      #loading-overlay #logo{animation:floatUp 4s ease-in-out infinite alternate}
      @keyframes appearDisappear{0%{transform:translateY(0);opacity:0}20%{transform:translateY(-2px);opacity:1}80%{transform:translateY(-4px);opacity:1}100%{transform:translateY(-6px);opacity:0}}
      #loading-overlay .overlay-square-big{width:8px;height:8px;fill:#0bc0b4;animation:appearDisappear 4s ease-in-out infinite}
      #loading-overlay .overlay-square-med{width:5px;height:5px;fill:#2f68ae;animation:appearDisappear 4s ease-in-out infinite}
      #loading-overlay .overlay-square-small{width:3px;height:3px;fill:#fff;animation:appearDisappear 4s ease-in-out infinite}
      #loading-overlay .overlay-sq1{animation-delay:.4s} .overlay-sq2{animation-delay:.8s} .overlay-sq3{animation-delay:1.2s}
      .overlay-sq4{animation-delay:1.6s} .overlay-sq5{animation-delay:2.0s} .overlay-sq6{animation-delay:2.4s}
      .overlay-sq7{animation-delay:2.8s} .overlay-sq8{animation-delay:3.2s} .overlay-sq9{animation-delay:3.6s} .overlay-sq10{animation-delay:4.0s}
      #loading-overlay .loading-text{font-size:16px;margin:2px 0;color:#fff;font-family:'Cabin',sans-serif;text-align:center}
      #loading-overlay .msg{margin-top:10px;color:#fff;text-align:center;max-width:90%}
      #loading-overlay .actions{margin-top:14px}
      #loading-overlay .btn-continue{background:#ffffff;border:0;color:#0b1722;padding:8px 14px;border-radius:6px;cursor:pointer}
      @media (max-width:600px){
        #loading-overlay .loading-logo-svg{width:200px}
        #loading-overlay .loading-text{font-size:12px;margin:1px 0}
      }
    `;
    document.head.appendChild(style);
  }

  function showLoadingAnimation(text = 'Estamos preparando tu pedido...') {
    ensureOverlayStyles();
    if (document.getElementById('loading-overlay')) return;

    const overlay = document.createElement('div');
    overlay.id = 'loading-overlay';
    overlay.setAttribute('aria-busy', 'true');
    Object.assign(overlay.style, {
      position: 'fixed',
      top: '0', left: '0', width: '100%', height: '100%',
      backgroundColor: 'rgba(0,0,0,.5)',
      display: 'flex', flexDirection: 'column',
      justifyContent: 'center', alignItems: 'center',
      zIndex: '9999'
    });

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 100 100');
    svg.classList.add('loading-logo-svg');
    svg.innerHTML = `
      <defs><style>.cls-1{fill:#fff}.cls-2{fill:#2f68ae}.cls-3{fill:#0bc0b4}</style></defs>
      <g id="logo" transform="translate(50,50)"><g id="Capa_2"><g id="Capa_1-2">
        <path class="cls-1" d="M46,27.85c.66,0,1.32,0,2,0a15.27,15.27,0,0,1,0,2c-.66,0-1.33,0-2-.05C46.05,29.16,46.05,28.5,46,27.85Z"/>
        <path class="cls-2" d="M2.61,0H5c0,.74,0,1.49,0,2.24a18.55,18.55,0,0,1-2.36-.06C2.6,1.46,2.6.73,2.61,0Z"/>
        <path class="cls-2" d="M4.41,3.4c1.16-.06,2.32,0,3.48,0a33.45,33.45,0,0,1,0,3.47H4.48c-.11,1.43.12,2.9-.1,4.29-1.4,0-2.81,0-4.22,0a13.29,13.29,0,0,1,0-4.36c1.41,0,2.81,0,4.22,0C4.42,5.64,4.43,4.52,4.41,3.4Z"/>
        <path class="cls-2" d="M6.47,9A4.21,4.21,0,0,1,7.7,8.94c1.23.05,2.46-.07,3.69.07-.05,11.48,0,23,0,34.46A16.17,16.17,0,0,0,39.07,55c1.84,1.66,3.54,3.48,5.35,5.18.74.75,1.52,1.45,2.22,2.24a26.59,26.59,0,0,1-16.59,7.91,13.16,13.16,0,0,1-5.23,0,26.81,26.81,0,0,1-24-26.47c0-9.48,0-19,0-28.43,0-.4,0-.8.05-1.19,1.87,0,3.73,0,5.6,0C6.46,12.5,6.34,10.75,6.47,9Z"/>
        <path class="cls-3" d="M24.19,17.13a26.84,26.84,0,0,1,17,3.53,24.08,24.08,0,0,1,5.38,4.2A26.38,26.38,0,0,1,44.26,27c-1.59,1.61-3.39,3-5,4.61-.2.24-.58.51-.83.2a16.32,16.32,0,0,0-7.77-3.91,17.55,17.55,0,0,0-8.57.56c-.17-3.57,0-7.16-.11-10.74A6.58,6.58,0,0,1,24.19,17.13Z"/>
        <path class="cls-3" d="M26.24,37.83a8,8,0,0,1,2.76,0,6.27,6.27,0,0,1,2.57,1.39,5.56,5.56,0,0,1,1.77,3,6,6,0,0,1-2.85,6.65A6.13,6.13,0,0,1,23.38,48a6.32,6.32,0,0,1-1.8-4,6.39,6.39,0,0,1,1.82-4.79A7.07,7.07,0,0,1,26.24,37.83Z"/>
        <path class="cls-1" d="M47.61,30.74c1,0,1.93,0,2.89,0,.06,1,0,2,0,2.93-.94,0-1.9,0-2.84,0-.14,1.17,0,2.38,0,3.56-1.23.06-2.46,0-3.69,0,0-1.22,0-2.44,0-3.65,1.2,0,2.4,0,3.6,0C47.6,32.66,47.57,31.7,47.61,30.74Z"/>
        <path class="cls-1" d="M49.26,35.46c1.61,0,3.22,0,4.83,0,0,5.94,0,11.87,0,17.81-3.54,0-7.07,0-10.61,0,0-4.45,0-8.89,0-13.33,1.94,0,3.88,0,5.82,0C49.27,38.42,49.28,36.94,49.26,35.46Z"/>
      </g></g></g>
      <g id="cuadritos">
        <rect x="-20" y="10" class="overlay-square-med overlay-sq1"></rect>
        <rect x="35"  y="0"  class="overlay-square-small overlay-sq2"></rect>
        <rect x="15"  y="85" class="overlay-square-small overlay-sq3"></rect>
        <rect x="0"   y="-20" class="overlay-square-small overlay-sq4"></rect>
        <rect x="-15" y="70" class="overlay-square-med overlay-sq5"></rect>
        <rect x="-10" y="45" class="overlay-square-small overlay-sq6"></rect>
        <rect x="80"  y="55" class="overlay-square-med overlay-sq7"></rect>
        <rect x="50"  y="80" class="overlay-square-big overlay-sq8"></rect>
        <rect x="55"  y="-7" class="overlay-square-med overlay-sq9"></rect>
        <rect x="70"  y="25" class="overlay-square-small overlay-sq10"></rect>
      </g>
    `;

    const msg = document.createElement('div');
    msg.id = 'status-messages';
    msg.innerHTML = `
      <p class="loading-text">${text}</p>
      <p class="loading-text">Espera un momento por favor.</p>
    `;

    // Botón opcional de continuar si la API falla (no se muestra por defecto)
    const actions = document.createElement('div');
    actions.className = 'actions';
    actions.style.display = 'none';
    actions.innerHTML = `<button type="button" class="btn-continue" id="btn-continue-checkout">Continuar al checkout</button>`;

    document.body.appendChild(overlay);
    overlay.appendChild(svg);
    overlay.appendChild(msg);
    overlay.appendChild(actions);

    // Fallback manual si hiciera falta (solo se muestra en error)
    actions.querySelector('#btn-continue-checkout')?.addEventListener('click', () => {
      goCheckoutNow();
    });
  }

  function updateOverlayMessage(text) {
    const sm = document.getElementById('status-messages');
    if (sm) {
      sm.innerHTML = `<p class="loading-text">${text}</p>`;
    }
  }

  function showContinueButton() {
    const actions = document.querySelector('#loading-overlay .actions');
    if (actions) actions.style.display = 'block';
  }

  function hideLoadingAnimation() {
    document.getElementById('loading-overlay')?.remove();
  }

  // Exponer por si otros scripts lo usan
  window.showLoadingAnimation = showLoadingAnimation;
  window.hideLoadingAnimation = hideLoadingAnimation;

  // ==============================
  // Navegación a Checkout
  // ==============================
  function goCheckoutNow() {
    const cartForm = document.querySelector('#cart');
    if (cartForm && cartForm.tagName === 'FORM') {
      let hidden = cartForm.querySelector('input[name="checkout"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'checkout';
        hidden.value = '1';
        cartForm.appendChild(hidden);
      }
      cartForm.submit();
    } else {
      window.location.assign('/checkout');
    }
  }

  // ==============================
  // Validación con backend (espera real)
  // ==============================
  async function validateWithBackend(variantIds) {
    try {
      updateOverlayMessage('Comprobando existencias y precios...');
      const res = await fetch(BACKEND_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        credentials: 'omit',
        body: JSON.stringify({ variant_ids: variantIds })
      });

      if (!res.ok) {
        console.error('Backend respondió con estado no OK:', res.status);
        return { ok: false, data: null };
      }
      const data = await res.json();
      const ok = !!data && data.success === true;
      return { ok, data };
    } catch (err) {
      console.error('Error al validar con backend:', err);
      return { ok: false, data: null };
    }
  }

  // ==============================
  // Recolectar Variant IDs del carrito
  // ==============================
  function collectVariantIds() {
    const ids = new Set();

    // a) Inputs con data-quantity-variant-id (drawer/cart moderno)
    document.querySelectorAll('input[data-quantity-variant-id]').forEach(inp => {
      const vid = inp.getAttribute('data-quantity-variant-id');
      const qty = parseInt(inp.value, 10) || 0;
      if (vid && qty > 0) ids.add(vid);
    });

    // b) Fallback por enlaces con ?variant=
    if (ids.size === 0) {
      document.querySelectorAll('[id^="CartItem"], [id^="CartDrawer-Item"]').forEach(row => {
        const link = row.querySelector('a[href*="/products/"]');
        if (link && link.href.includes('?')) {
          const params = new URLSearchParams(link.href.split('?')[1] || '');
          const vid = params.get('variant');
          if (vid) ids.add(vid);
        }
      });
    }

    return Array.from(ids);
  }

  // ==============================
  // Checkout con validación previa
  // ==============================
  let _checkoutInFlight = false;

  async function handleCheckout() {
    if (_checkoutInFlight) return;
    _checkoutInFlight = true;

    try {
      const variantIds = collectVariantIds();

      // IMPORTANTE:
      // Si no logramos encontrar variant IDs, no bloqueamos la compra.
      if (!variantIds.length) {
        console.warn('No se encontraron variant IDs en el carrito. Continuando al checkout sin validar backend.');
        goCheckoutNow();
        return;
      }

      // Mostrar overlay y arrancar validación
      showLoadingAnimation('Estamos preparando tu pedido...');
      const { ok } = await validateWithBackend(variantIds);

      if (!ok) {
        // En error, permitimos continuar para no perder la compra
        updateOverlayMessage('No se pudo validar con el proveedor. Continuaremos al checkout…');
      } else {
        updateOverlayMessage('¡Listo! Redirigiendo al checkout…');
      }

      // Ir a checkout al terminar la validación (éxito o fallo)
      goCheckoutNow();
    } catch (e) {
      console.error('Error en handleCheckout:', e);
      // Por seguridad, si algo falla, procede al checkout
      goCheckoutNow();
    } finally {
      _checkoutInFlight = false;
    }
  }

  // ==============================
  // Listeners delegados (móvil y DOM dinámico)
  // ==============================
  document.addEventListener('click', (event) => {
    const payBtn  = event.target.closest('#miPagarPedido, #CartDrawer-Checkout, #checkout');
    const viewBtn = event.target.closest('#miVerCarrito');

    // Pagar / Checkout
    if (payBtn) {
      if (payBtn.hasAttribute('disabled') || payBtn.getAttribute('aria-disabled') === 'true') return;
      event.preventDefault();
      handleCheckout();
      return;
    }

    // Ver carrito
    if (viewBtn) {
      event.preventDefault();
      window.location.href = '/cart';
      return;
    }
  });

  // Limpieza (iOS bfcache)
  window.addEventListener('pagehide', () => {
    _checkoutInFlight = false;
    hideLoadingAnimation();
  });

  // Compatibilidad IE (envío nativo del form)
  document.addEventListener('DOMContentLoaded', () => {
    try {
      if (isIE()) {
        const cartForm = document.querySelector('#cart');
        if (cartForm) {
          const hiddenInput = document.createElement('input');
          hiddenInput.name = 'checkout';
          hiddenInput.type = 'hidden';
          cartForm.appendChild(hiddenInput);
          document.querySelector('#checkout')?.addEventListener('click', () => {
            cartForm.submit();
          });
        }
      }
      console.log('animacionCarrito.js inicializado');
    } catch (err) {
      console.error('animacionCarrito init error:', err);
    }
  });
})();
